import { styled, Box } from '@mui/system'
import React, { Fragment } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import useSettings from 'app/hooks/useSettings'
import { Paragraph, Span } from '../Typography'
import { Icon, ButtonBase, } from '@mui/material'
import MatxVerticalNavExpansionPanel from './MatxVerticalNavExpansionPanel'
import { blue } from '@mui/material/colors'


const ListLabel = styled(Paragraph)(({ theme, mode }) => ({
    fontSize: '12px',
    marginTop: '20px',
    marginLeft: '15px',
    marginBottom: '10px',
    textTransform: 'uppercase',
    display: mode === 'compact' && 'none',
    color: theme.palette.text.secondary,
    // color: "red",
}))

const ExtAndIntCommon = {
    // domyślny przycisk, nie rozwiajny -> Dasboard, savings, statiscics
    // border: '1px solid red',
    display: 'flex',
    overflow: 'hidden',
    borderRadius: '14px',
    padding: '0 0 0 5px',
    height: 50,
    width: 200,
    whiteSpace: 'pre',
    marginBottom: '10px',
    textDecoration: 'none',
    justifyContent: 'space-between',
    transition: 'all 150ms ease-in',
    '&:hover': {
        background: 'rgba(0, 0, 0, 0.08)',
        // backgroundColor: '#7d53de',
    },
    '&.compactNavItem': {
        overflow: 'hidden',
        justifyContent: 'center !important',
    },
    '& .icon': {
        fontSize: '18px',
        paddingLeft: '16px',
        paddingRight: '16px',
        verticalAlign: 'middle',
    },
}
const ExternalLink = styled('a')(({ theme }) => ({
    ...ExtAndIntCommon,
    // color: theme.palette.text.primary,
}))

const InternalLink = styled(Box)(({ theme }) => ({
    borderRadius: "10px",
    
    '& a': {
        ...ExtAndIntCommon,
        // color: theme.palette.text.primary,
        color: "#475569",
    },
    '& .navItemActive': {
        color: "#fff",
        backgroundColor: '#7d53de',
    },
    // '.children .navItemActive': {
    //     color: "red",
    //     backgroundColor: 'red',
    // },
}))

const StyledText = styled(Span)(({ mode }) => ({
    fontFamily: "Titillium Web",
    fontSize: '16px',
    fontWeight: "400",
    paddingLeft: '0.8rem',
    display: mode === 'compact' && 'none',
}))

// const BulletIcon = styled('div')(({ theme }) => ({
//     padding: '2px',
//     marginLeft: '24px',
//     marginRight: '8px',
//     overflow: 'hidden',
//     borderRadius: '300px',
//     background: theme.palette.text.primary,
//     background: "red",
// }))

const BadgeValue = styled('div')(() => ({
    padding: '1px 8px',
    overflow: 'hidden',
}))


const Img = styled('img')(()=>({
    "&.active":{
        filter: "invert(100%) sepia(100%) saturate(0%) hue-rotate(104deg) brightness(103%) contrast(103%)"
    }
}))


const MatxVerticalNav = ({ items }) => {
    const { settings } = useSettings();
    const { mode } = settings.layout1Settings.leftSidebar
    const location = useLocation();

    const renderLevels = (data, idd, dynamic) => {
        return data.map((item, index) => {
            const isActive = item.path === location.pathname
            if (item.type === 'label')
                return (
                    <ListLabel
                        key={index}
                        mode={mode}
                        className="sidenavHoverShow"
                    >
                        {item.label}
                    </ListLabel>
                )
            if (item.children) {
                return (
                    // Przycisk rozwijany
                    <MatxVerticalNavExpansionPanel
                        mode={mode}
                        item={item}
                        key={index}
                        className="children"
                    >
                        {renderLevels(item.children, index, item.dynamic)}
                    </MatxVerticalNavExpansionPanel>
                )
            } else if (item.type === 'extLink') {
                return (
                    <ExternalLink
                        key={index}
                        href={item.path}
                        className={`${mode === 'compact' && 'compactNavItem'}`}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <ButtonBase
                            key={item.name}
                            name="child"
                            sx={{ 
                                width: '100%',
                            }}
                        >
                            {(() => {
                                if (item.icon) {
                                    return (
                                        <Icon className="icon">
                                            {item.icon}
                                        </Icon>
                                        // <img src={item.icon} />
                                    )
                                } else {
                                    return (
                                        <span className="item-icon icon-text">
                                            {item.iconText}
                                        </span>
                                    )
                                }
                            })()}
                            <StyledText
                                mode={mode}
                                className="sidenavHoverShow"
                            >
                                {item.name}
                            </StyledText>
                            <Box mx="auto"></Box>
                            {item.badge && (
                                <BadgeValue>{item.badge.value}</BadgeValue>
                            )}
                        </ButtonBase>
                    </ExternalLink>
                )
            } else {
                return (
                    //Przyciski bezpośrednie -> Help, settings, savings
                    <InternalLink key={index}
                    >
                        <NavLink
                            to={item.path}
                            className={({ isActive }) =>
                                isActive ? `navItemActive ${mode === 'compact' && 'compactNavItem'}` : `${mode === 'compact' && 'compactNavItem'}`
                            }
                        >
                            {/* Przycisk nie rozwijany -> Savings, Access request, Help settings... */}
                            <ButtonBase
                                key={item.name}
                                name="child"
                                sx={{
                                padding:'10px', 
                                width: '100%',
                                // background: 'pink'
                            }}
                            >
                                {item?.icon ? (
                                        <Img 
                                            src={require(`../../views/Keno/Icons/${item.icon}.svg`).default} 
                                            className={isActive ? "active" : ""}
                                            alt={item.icon}
                                            />

                                        ) : (
                                    <Fragment>
                                        {/* <BulletIcon
                                            className={`nav-bullet`}
                                            sx={{
                                                display:
                                                    mode === 'compact' && 'none',
                                            }}
                                        /> */}
                                        <Box
                                            className="nav-bullet-text"
                                            sx={{
                                                ml: '20px',
                                                fontSize: '11px',
                                                display:
                                                    mode !== 'compact' && 'none',
                                            }}
                                        >
                                            {item.iconText}
                                        </Box>
                                    </Fragment>
                                )}
                                <StyledText
                                    mode={mode}
                                    className="sidenavHoverShow"
                                >
                                    {item.name}
                                </StyledText>
                                <Box mx="auto"></Box>
                                {item.badge && (
                                    <BadgeValue className="sidenavHoverShow">
                                        {item.badge.value}
                                    </BadgeValue>
                                )}
                            </ButtonBase>
                        </NavLink>
                    </InternalLink>
                )
            }
        })
    }

    return <div className="navigation">{renderLevels(items, 0, false)}</div>
}

export default MatxVerticalNav
